export default __webpack_public_path__ + "static/media/starWars.e9345532.webp";